module.exports = __webpack_public_path__ + "static/media/time-left.c34743db.png";